import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { connect, useSelector } from 'react-redux';
import momen from 'moment'
import moment from 'moment-timezone'
import lang from '../../language/services/Lang';

const DateTime = (props) => {

    const { value, fallbackValue, dateAndTime, includeSeconds, compact, boldValue} = props

    const [momentDate, setMomentDate] = useState(null)
    const [momentTime, setMomentTime] = useState(null)
    const [zoneAbbr, setzoneAbbr] = useState('')
    const [datePrecursor, setDatePrecursor] = useState('')
    const [timePrecursor, setTimePrecursor] = useState('')

    const language = useSelector(state => state.layout.lang)

    const hasIsoOffset = (dateString) => {
        // used to check whether the date string we receive has any kind of offset identified.
        // This will match on any '+00:00', or 'Z' offset identifiers

        // Regex modified from here: https://rgxdb.com/r/144C2KWS
        return /(?:Z|([+-])(\d{2}):?(\d{2}))$/.test(dateString)
    }

    useEffect(() => {
        setDatePrecursor(lang.getValue(`${compact ? 'Compact.' : ''}DatePrecursor`, language))
        setTimePrecursor(lang.getValue(`${compact ? 'Compact.' : ''}TimePrecursor`, language))
    }, [language, compact])

    useEffect(() => {
        if (value) {            
           
            moment.updateLocale('fr-ca', momen.localeData()._config)
           
            var displayDate = '';
            let adjustedValue = value

            if (adjustedValue.toString().includes('T00:00:00')) {
                // no time to worry about, go ahead and make a date
                displayDate = new Date(adjustedValue)
            } else if (!hasIsoOffset(adjustedValue)) {
                // time was specified, but no offset, so add one
                // note: '+00:00' is equivalent to 'Z'
                displayDate = new Date(adjustedValue + '+00:00')
            } else {
                // create Date object with passed in ISO string
                displayDate = new Date(adjustedValue)
            }

            var momentTimeZone = moment.tz(displayDate, moment.tz.guess());
            
            if (momentTimeZone.isValid()) {
                const dateLocale = lang.getValue(`${compact ? 'Compact.' : ''}DateLocale`, language)
                const dateFormat = lang.getValue(`${compact ? 'Compact.' : ''}DateFormat`, language)
                const timeFormat = lang.getValue(`${compact ? 'Compact.' : ''}${includeSeconds ? 'TimeFormatWithSeconds' : 'TimeFormat'}`, language)                
                setMomentDate(momentTimeZone.locale(dateLocale).format(dateFormat))
                setMomentTime(momentTimeZone.locale(dateLocale).format(timeFormat))
                setzoneAbbr(momentTimeZone.zoneAbbr())
            }
        }
        else {
            setMomentDate(null)
            setMomentTime(null);
        }
    }, [value, language, includeSeconds, compact])
   
    return value ? (
        <span className={boldValue ? 'bold-weight' : ''}>
            {`${datePrecursor}${momentDate}`}
            {dateAndTime && `${timePrecursor}${momentTime ? ((language.toLowerCase() == 'en' || compact) ? momentTime : `${momentTime.split(" ")[0]} ${lang.getValue(`TimeZoneFormat.${zoneAbbr}`, language) == `TimeZoneFormat.${zoneAbbr}.${language}` ? `${zoneAbbr}` : `${lang.getValue(`TimeZoneFormat.${zoneAbbr}`, language)}`}`):''}`}
        </span>
    ) : (
            <span className={boldValue ? 'bold-weight' : ''}>{fallbackValue}</span>
        )
}

DateTime.propTypes = {
    lang: PropTypes.string,
    value: PropTypes.string,
    fallbackValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]), 
    dateAndTime: PropTypes.bool,
    includeSeconds: PropTypes.bool,
    compact: PropTypes.bool,
    boldValue: PropTypes.bool
};

const mapStateToProps = state => ({
    lang: state.layout.lang
})

export default connect(mapStateToProps)(DateTime)
